import React, { useEffect, useRef, useState } from 'react';
import api from '../api/api';

export default function CollectionReportDownload({ customerId, customerName, item, serial, sort, direction, onError }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const container = useRef(null);
  const trigger = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const close = (event) => {
      if (!container.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [open]);

  const download = async (format) => {
    setOpen(false);
    setLoading(true);
    try {
      const response = await api.get(`/customers/${customerId}/collection-report/download`, {
        params: { format, item, serial, sort, direction },
        responseType: 'blob',
      });
      const url = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Collection_Report_${String(customerName || 'Customer').replace(/[^a-z0-9]+/gi, '_')}.${format === 'excel' ? 'xlsx' : 'pdf'}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      onError?.('Failed to download collection report. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div ref={container} className="collection-report-download" onBlur={(event) => {
      if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
    }} onKeyDown={(event) => {
      if (event.key === 'Escape') {
        setOpen(false);
        trigger.current?.focus();
      }
    }}>
      <button ref={trigger} type="button" className="button collection-report-action-button"
        disabled={loading || !customerId} aria-expanded={open}
        onClick={() => setOpen(value => !value)}>
        {loading ? 'Downloading…' : 'Download ▾'}
      </button>
      {open && (
        <div aria-label="Download format" className="collection-report-download-menu">
          {['pdf', 'excel'].map(format => (
            <a key={format} className="collection-report-download-link"
              href={api.getUri({
                url: `/customers/${customerId}/collection-report/download`,
                params: { format, item, serial, sort, direction },
              })}
              onClick={(event) => {
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                event.preventDefault();
                download(format);
              }}>
              <svg className={`collection-report-file-icon ${format}`} viewBox="0 0 32 36" aria-hidden="true" focusable="false">
                <path d="M6 1h13l7 7v26H6z" fill="none" stroke="currentColor" strokeWidth="2" />
                <path d="M19 1v8h7" fill="none" stroke="currentColor" strokeWidth="2" />
                <rect x="1" y="16" width="30" height="14" rx="2" fill="currentColor" />
                <text x="16" y="26" textAnchor="middle" fill="#fff" fontFamily="Arial, sans-serif" fontSize="10" fontWeight="bold">
                  {format === 'pdf' ? 'PDF' : 'XLS'}
                </text>
              </svg>
              <span>{format === 'pdf' ? 'PDF' : 'Excel'}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
